import styled from "styled-components";

export const StepTwoContainer = styled.div`
  color: #455a64;

  .title-container {
    img {
      display: block;
    }

    p {
      margin: 0;
      font-size: 16px;
      line-height: 1.32;
    }
  }

  .payment-methods {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin: -24px -24px 24px;
    padding: 12px 24px;
    background: #ffffff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .method-tab {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      gap: 4px;
      height: 32px;
      padding: 0 8px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      background: #ffffff;
      cursor: pointer;
      font-family: inherit;

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      span {
        padding: 0 4px;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.42;
        color: #1f1f1f;
      }
    }

    .method-tab.active {
      background: #d4d4d4;
      border-color: transparent;
    }
  }
`;
